import { object, string } from 'yup';

import { ValidationErrorMessages } from './types';

export const editEmailValidation = object({
  email: string()
    .required(ValidationErrorMessages.REQUIRED)
    .email(ValidationErrorMessages.EMAIL),
});
